import { Observable } from "rxjs"
import { ObservableFromFetch } from "../../ObservableFromFetch"

export interface MappingField {
  FieldGroup : string
  Required: boolean
  Active: boolean
  Name: string
  UniqueName: string
}

export interface MappingFields {
  Required : MappingField[]
  IDFields : MappingField[]
  Other : MappingField[]
  Supervisor1 : MappingField[]
  Supervisor2 : MappingField[]
}

export default function MappingFieldsGetObservable(importJobID: number): Observable<MappingFields> {
  const params: string = JSON.stringify({ ImportJobID: importJobID })
  return ObservableFromFetch<MappingFields>("WorkforceImport/GetPersonnelImportDropdown", params)
}
